export enum StatusType {
  OPEN = 0, // 分闸
  CLOSED = 1, // 合闸
  PENDING = 2, // 下发中
}

export const statusOptions = [
  { label: '全部', value: 9999 },
  { label: '合闸', value: StatusType.CLOSED },
  { label: '分闸', value: StatusType.OPEN },
];

export const controlOptions = [
  { label: '远程合闸', value: StatusType.CLOSED },
  { label: '远程分闸', value: StatusType.OPEN },
];

export enum DistributeStatus {
  PENDING = 0,
  SUCCESS = 1,
  FAIL = 2,
  FINISH = 3,
}

export const DistributeStatusDisplay = {
  [DistributeStatus.PENDING]: '下发中',
  [DistributeStatus.SUCCESS]: '成功',
  [DistributeStatus.FAIL]: '失败',
};

export const DistributeStatusTag = {
  [DistributeStatus.PENDING]: 'warning',
  [DistributeStatus.SUCCESS]: 'success',
  [DistributeStatus.FAIL]: 'danger',
};
